var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 57,
    viewBox: "0 0 31 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34359 28.5089L29.861 49.3062C30.2217 49.67 30.5079 50.1026 30.7032 50.579C30.8985 51.0554 30.9991 51.5663 30.9991 52.0823C30.9991 52.5983 30.8985 53.1092 30.7032 53.5856C30.5079 54.062 30.2217 54.4946 29.861 54.8584C29.1304 55.5916 28.1441 56.0028 27.1164 56.0028C26.0887 56.0028 25.1025 55.5916 24.3718 54.8584L1.12698 31.3036C0.42466 30.5884 0.0210761 29.6261 0.000125822 28.6168C-0.0208245 27.6075 0.34247 26.6288 1.01449 25.8842L24.3557 2.14541C25.0815 1.40698 26.0668 0.991279 27.0947 0.98975C28.1226 0.988222 29.109 1.40099 29.8369 2.13725C30.5648 2.87352 30.9746 3.87296 30.9761 4.91573C30.9776 5.95849 30.5708 6.95915 29.845 7.69757L9.34359 28.5089Z",
    fill: "#0D0D0D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderIcon);
export default __webpack_public_path__ + "static/media/slider_icon.fcf88118.svg";
export { ForwardRef as ReactComponent };